import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {ButtonContainer} from 'app/components/tv/customControls/SharedCustomControlsStyles';
import {Close, Replay, SkipNext} from '@mui/icons-material';
import {FONTS, SIZES, Typography} from '@fupa/fupa-uikit';

const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 9997;
  background-color: rgba(0, 0, 0, 0.5);
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 ${SIZES['32']};
`;

const Label = styled(Typography)`
  font-size: ${FONTS['16']};
  margin-top: ${SIZES['16']};
`;

const DESKTOP_SIZES = {container: '3em', icon: '1.5em'};
const MOBILE_SIZES = {container: '2em', icon: '1em'};

const StyledReplay = styled(Replay)`
  font-size: ${props => props.$iconSize};
`;
const StyledSkipNext = styled(SkipNext)`
  font-size: ${props => props.$iconSize};
`;
const StyledClose = styled(Close)`
  font-size: ${props => props.$iconSize};
`;

export const FinishedPlaylistOverlay = ({
  show,
  handleClose,
  handleRestart,
  handleStartNewVideo,
  isMobile,
  currentVideoIndex,
  playlistLength,
}) => {
  const [sizes, setSizes] = useState(DESKTOP_SIZES);
  useEffect(() => setSizes(isMobile ? MOBILE_SIZES : DESKTOP_SIZES), [isMobile]);

  const secondaryAction =
    currentVideoIndex < playlistLength - 1 ? (
      <ButtonWrapper>
        <ButtonContainer onClick={handleStartNewVideo} title='Neues Video ansehen' bgColor dim={sizes.container}>
          <StyledSkipNext color={'icon-invert'} $iconSize={sizes.icon} />
        </ButtonContainer>
        <Label variant='title1'>Neues Video ansehen</Label>
      </ButtonWrapper>
    ) : (
      <ButtonWrapper>
        <ButtonContainer onClick={handleRestart} title='Nochmal' bgColor dim={sizes.container}>
          <StyledReplay color={'icon-invert'} $iconSize={sizes.icon} />
        </ButtonContainer>
        <Label variant='title1'>Nochmal</Label>
      </ButtonWrapper>
    );

  return show ? (
    <OverlayContainer>
      <ButtonWrapper>
        <ButtonContainer onClick={handleClose} title='Schließen' bgColor dim={sizes.container}>
          <StyledClose color={'icon-invert'} $iconSize={sizes.icon} />
        </ButtonContainer>
        <Label variant='title1'>Schließen</Label>
      </ButtonWrapper>
      {secondaryAction}
    </OverlayContainer>
  ) : null;
};
